// import React, { useEffect, useRef, useState } from "react";
// import { motion, useAnimation, Variants } from "framer-motion";
// import TaskAltIcon from '@mui/icons-material/TaskAlt';
// const CompanyHistory = () => {

//   const sectionRef = useRef<HTMLDivElement>(null);
//   const controls = useAnimation();
//   const variants = {
//     hiddenLeft: { opacity: 0, x: -100 },
//     hiddenRight: { opacity: 0, x: 100 },
//     visible: {
//       opacity: 1,
//       x: 0,
//       transition: { duration: 1, ease: "easeOut" },
//     },
//   };

//   const [prevY, setPrevY] = useState(0);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         const currentY = entry.boundingClientRect.y;

//         if (entry.isIntersecting && currentY > prevY) {
//           controls.start("visible");
//         }
//         setPrevY(currentY);
//       },
//       { threshold: 0.2 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }
//     };
//   }, [controls, prevY]);

//   return (

//     <div
//       ref={sectionRef}
//       className="bg-[#AB052D] lg:py-5 lg:pb-28  relative  lg:overflow-visible z-20"
//     >

//       <h4 className="text-white hidden lg:block text-2xl font-normal pl-36  pt-10">
//         Our Company Office</h4>
//       <div className="border-b hidden lg:block  border-white border-opacity-30 mx-36 my-5"></div>

//       <div className="grid grid-cols-6 overflow-hidden max-w-7xl mx-auto">
//         <motion.div
//           initial="hiddenLeft"
//           animate={controls}
//           variants={variants}
//           className="lg:col-span-3 flex justify-center col-span-6 lg:py-10 lg:px-5"
//         >
//           <div className="hidden lg:block">
//             <img
//               src="/assets/image/office_bg.png"
//               alt="Hydraulic excavator arm against blue sky"
//               className="w-[110vh] h-[70vh] object-cover"
//             />
//           </div>
//           <div
//             style={{
//               backgroundImage: "url('/assets/image/office_bg.png')",
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//             }}
//             className="w-full h-[70vh] block lg:hidden"
//           >
//             <h4 className="text-white text-2xl font-normal pl-8 pt-7">
//               Our Company Office
//             </h4>
//             <div className="border-b border-b-gray-200 my-5 mx-8"></div>
//           </div>
//         </motion.div>

//         <motion.div
//           initial="hiddenRight"
//           animate={controls}
//           variants={variants}
//           className="lg:mt-[170px] lg:col-span-3 font-normal text-sm lg:text-xl col-span-6 lg:pr-40 leading-loose lg:leading-[2rem] p-6 flex flex-col items-start text-white"
//         >
//           <p className="text-lg lg:text-[20px] leading-loose lg:leading-[2rem]">Siskon Venture PVT. LTD. came into existence in 2017 , promoted by the owners of SISKON GROUP OF COMPANIES with the experience of more than 35 years in the field of CORE HYDRAULICS , AUTOMATION AND FILTRATION.</p>

//         </motion.div>
//       </div>
//     </div>
//   )

// };

// export default CompanyHistory;

// import React from "react";
// import { motion, Variants } from "framer-motion";
// import TaskAltIcon from "@mui/icons-material/TaskAlt";
// import { globalTransition } from "../../../assets/animate/globalAnimation";

// const CompanyHistory = () => {
//   // Define variants matching the sample component
//   const containerVariants: Variants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.3, // Matches sample component
//         ...globalTransition,
//       },
//     },
//   };

//   const childVariants: Variants = {
//     hidden: { opacity: 0, x: -100 },
//     visible: {
//       opacity: 1,
//       x: 0,
//       transition: { ...globalTransition, ease: "easeOut" }, // Matches sample
//     },
//   };

//   const rightChildVariants: Variants = {
//     hidden: { opacity: 0, x: 100 },
//     visible: {
//       opacity: 1,
//       x: 0,
//       transition: { ...globalTransition, ease: "easeOut" }, // Matches sample
//     },
//   };

//   return (
//     <div className="bg-[#AB052D] lg:py-5 lg:pb-28 relative lg:overflow-visible z-20">
//       <h4 className="text-white hidden lg:block text-2xl font-normal pl-36 pt-10">
//         Our Company Office
//       </h4>
//       <div className="border-b hidden lg:block border-white border-opacity-30 mx-36 my-5"></div>

//       {/* Apply container variants */}
//       <motion.div
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true, amount: 0.1 }} // Trigger when 10% is in view
//         variants={containerVariants}
//         className="grid grid-cols-6 overflow-hidden  w-full  items-center"
//       >
//         <motion.div
//           variants={childVariants} // Left animation
//           className="lg:col-span-3 flex justify-start col-span-6 lg:py-10 lg:pl-36"
//         >
//           <div className="hidden lg:block">
//             <img
//               src="/assets/image/company_img.jpg"
//               alt="Hydraulic excavator arm against blue sky"
//               className=" w-full h-[60vh]  object-cover"
//             />
//           </div>
//           <div
//             style={{
//               backgroundImage: "url('/assets/image/company_img.jpg')",

//               backgroundPosition: "center",
//             }}
//             className="w-full bg-cover h-[60vh] block lg:hidden"
//           >
//             <h4 className="text-white text-2xl font-normal pl-8 pt-7">
//               Our Company Office
//             </h4>
//             <div className="border-b border-b-gray-200 my-5 mx-8"></div>
//           </div>
//         </motion.div>

//         <motion.div
//           variants={rightChildVariants} // Right animation
//           className="lg:mt-[170px] lg:col-span-3 font-normal text-sm lg:text-xl col-span-6 lg:pr-40 leading-loose lg:leading-[2rem] p-6 flex flex-col items-start text-white"
//         >
//           <p className="text-lg lg:text-[20px] leading-loose lg:leading-[2rem]">
//             Siskon Venture PVT. LTD. came into existence in 2017, promoted by
//             the owners of SISKON GROUP OF COMPANIES with the experience of more
//             than 35 years in the field of CORE HYDRAULICS, AUTOMATION AND
//             FILTRATION.
//           </p>
//         </motion.div>
//       </motion.div>
//     </div>
//   );
// };

// export default CompanyHistory;

import React from "react";
import { motion, Variants } from "framer-motion";
import { globalTransition } from "../../../assets/animate/globalAnimation";

const CompanyHistory = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        ...globalTransition,
      },
    },
  };

  const childVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { ...globalTransition, ease: "easeOut" },
    },
  };

  const rightChildVariants = {
    hidden: { opacity: 0, x: 100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { ...globalTransition, ease: "easeOut" },
    },
  };

  return (
    <div className="bg-[#AB052D] w-full">
      {/* Mobile and Minimized Tab View */}
      <div className="lg:hidden flex flex-col">
        {/* Image section with title overlay without black background */}
        <div className="relative">
          <div className="absolute top-0 left-0 w-full p-4 z-10">
            <h4 className="text-white text-2xl font-normal">
              Our Company Office
            </h4>
            <div className="border-b border-white my-4"></div>
          </div>

          <img
            src="/assets/image/company_img.jpg"
            alt="Siskon Ventures office with employees in a meeting"
            className="w-full h-[500px] sm:h-[600px] object-cover object-center"
          />
        </div>

        {/* Text section for mobile */}
        <div className="bg-[#AB052D] p-6 text-white">
          <p className="text-lg leading-loose">
            Siskon Venture PVT. LTD. came into existence in 2017, promoted by
            the owners of SISKON GROUP OF COMPANIES with the experience of more
            than 35 years in the field of CORE HYDRAULICS, AUTOMATION AND
            FILTRATION.
          </p>
        </div>
      </div>

      {/* Desktop View */}
      <div className="hidden lg:block">
        <div className="px-10 xl:px-36 pt-10">
          <h4 className="text-white text-2xl font-normal">
            Our Company Office
          </h4>
          <div className="border-b border-white border-opacity-30 my-5"></div>
        </div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={containerVariants}
          className="grid grid-cols-6 w-full pb-28"
        >
          {/* Image Column */}
          <motion.div
            variants={childVariants}
            className="col-span-3 pl-10 xl:pl-36 py-10"
          >
            <div className="w-full">
              <img
                src="/assets/image/company_img.jpg"
                alt="Siskon Ventures office with employees in a meeting"
                className="w-full h-auto object-contain"
              />
            </div>
          </motion.div>

          {/* Text Column */}
          <motion.div
            variants={rightChildVariants}
            className="col-span-3 pr-10 xl:pr-40 mt-[70px] pl-8 text-white"
          >
            <p className="text-[20px] leading-[2rem]">
              Siskon Venture PVT. LTD. came into existence in 2017, promoted by
              the owners of SISKON GROUP OF COMPANIES with the experience of
              more than 35 years in the field of CORE HYDRAULICS, AUTOMATION AND
              FILTRATION.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default CompanyHistory;